/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../form-page-layout/form-page-layout.component.ngfactory';
import * as i2 from '../../../../../app/components/widgets/form-page-layout/form-page-layout.component';
import * as i3 from '../../../../../app/components/widgets/form-page/form-page.component';
import * as i4 from '@angular/forms';
import * as i5 from '../form-page-button-block/form-page-button-block.component.ngfactory';
import * as i6 from '../../../../../app/components/widgets/form-page-button-block/form-page-button-block.component';
import * as i7 from '@angular/common';
import * as i8 from '@angular/router';
const styles_FormPageWidget:any[] = ([] as any[]);
export const RenderType_FormPageWidget:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormPageWidget,data:{}});
export function View_FormPageWidget_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),13,'form-page-layout',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_FormPageLayoutWidget_0,
      i1.RenderType_FormPageLayoutWidget)),i0.ɵdid(1,49152,(null as any),0,i2.FormPageLayoutWidget,
      ([] as any[]),{title:[0,'title'],icon:[1,'icon'],errors:[2,'errors'],successes:[3,
          'successes'],goBackLink:[4,'goBackLink']},(null as any)),(_l()(),i0.ɵted(-1,
      0,['\n  '])),(_l()(),i0.ɵeld(3,0,(null as any),0,9,'form',[['ngNativeValidate',
      '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
      (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,
      'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
      'ngSubmit'],[(null as any),'submit'],[(null as any),'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.FormPageWidget = _v.component;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,4).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,4).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngSubmit' === en)) {
      const pd_2:any = ((<any>_co.save()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(4,16384,(null as any),0,i4.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),{ngSubmit:'ngSubmit'}),i0.ɵprd(2048,(null as any),
      i4.ControlContainer,(null as any),[i4.NgForm]),i0.ɵdid(6,16384,(null as any),
      0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),i0.ɵncd((null as any),0),(_l()(),
          i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(10,0,(null as any),
          (null as any),1,'form-page-button-block',([] as any[]),(null as any),(null as any),
          (null as any),i5.View_FormPageButtonBlockWidget_0,i5.RenderType_FormPageButtonBlockWidget)),
      i0.ɵdid(11,49152,(null as any),0,i6.FormPageButtonBlockWidget,[i7.Location,i8.Router],
          {showSave:[0,'showSave'],cancelText:[1,'cancelText'],goBackLink:[2,'goBackLink']},
          (null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵted(-1,
          0,['\n']))],(_ck,_v) => {
    var _co:i3.FormPageWidget = _v.component;
    const currVal_0:any = _co.title;
    const currVal_1:any = _co.icon;
    const currVal_2:any = _co.errors;
    const currVal_3:any = _co.successes;
    const currVal_4:any = _co.goBackLink;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_12:any = _co.showSave;
    const currVal_13:any = _co.cancelText;
    const currVal_14:any = _co.goBackLink;
    _ck(_v,11,0,currVal_12,currVal_13,currVal_14);
  },(_ck,_v) => {
    const currVal_5:any = i0.ɵnov(_v,6).ngClassUntouched;
    const currVal_6:any = i0.ɵnov(_v,6).ngClassTouched;
    const currVal_7:any = i0.ɵnov(_v,6).ngClassPristine;
    const currVal_8:any = i0.ɵnov(_v,6).ngClassDirty;
    const currVal_9:any = i0.ɵnov(_v,6).ngClassValid;
    const currVal_10:any = i0.ɵnov(_v,6).ngClassInvalid;
    const currVal_11:any = i0.ɵnov(_v,6).ngClassPending;
    _ck(_v,3,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
  });
}
export function View_FormPageWidget_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'form-page',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormPageWidget_0,
      RenderType_FormPageWidget)),i0.ɵdid(1,49152,(null as any),0,i3.FormPageWidget,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FormPageWidgetNgFactory:i0.ComponentFactory<i3.FormPageWidget> = i0.ɵccf('form-page',
    i3.FormPageWidget,View_FormPageWidget_Host_0,{title:'title',icon:'icon',errors:'errors',
        successes:'successes',showSave:'showSave',cancelText:'cancelText',goBackLink:'goBackLink',
        save:'save'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2Zvcm0tcGFnZS9mb3JtLXBhZ2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2Zvcm0tcGFnZS9mb3JtLXBhZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vdXNyL3NyYy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3dpZGdldHMvZm9ybS1wYWdlL2Zvcm0tcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2Zvcm0tcGFnZS9mb3JtLXBhZ2UuY29tcG9uZW50LnRzLkZvcm1QYWdlV2lkZ2V0X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGZvcm0tcGFnZS1sYXlvdXQgW3RpdGxlXT1cInRpdGxlXCJcbiAgICAgICAgICAgICAgICAgIFtlcnJvcnNdPVwiZXJyb3JzXCJcbiAgICAgICAgICAgICAgICAgIFtzdWNjZXNzZXNdPVwic3VjY2Vzc2VzXCJcbiAgICAgICAgICAgICAgICAgIFtnb0JhY2tMaW5rXT1cImdvQmFja0xpbmtcIlxuICAgICAgICAgICAgICAgICAgW2ljb25dPVwiaWNvblwiPlxuICA8Zm9ybSBuZ05hdGl2ZVZhbGlkYXRlIChuZ1N1Ym1pdCk9XCJzYXZlKClcIj5cbiAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgPGZvcm0tcGFnZS1idXR0b24tYmxvY2sgW2dvQmFja0xpbmtdPVwiZ29CYWNrTGlua1wiIFtjYW5jZWxUZXh0XT1cImNhbmNlbFRleHRcIiBbc2hvd1NhdmVdPVwic2hvd1NhdmVcIj48L2Zvcm0tcGFnZS1idXR0b24tYmxvY2s+XG4gIDwvZm9ybT5cbjwvZm9ybS1wYWdlLWxheW91dD4iLCI8Zm9ybS1wYWdlPjwvZm9ybS1wYWdlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3dDQUFBLFVBQUE7TUFBQTtVQUFBLHlEQUlnQztNQUFBLGFBQzlCO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBO0lBQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUF1QjtNQUFBO01BQUE7SUFBQTtJQUF2QjtFQUFBLHVDQUFBO01BQUEsK0RBQUE7MEJBQUEsa0NBQUE7TUFBQTtNQUEyQyxxREFDekMsa0JBQXlCO2lCQUFBLCtCQUN6QjtVQUFBO1VBQUE7YUFBQTtVQUFBO1VBQUEsZUFBMkgsNENBQ3RIO1VBQUE7O0lBUlM7SUFJQTtJQUhBO0lBQ0E7SUFDQTtJQUhsQixXQUFrQixVQUlBLFVBSEEsVUFDQSxVQUNBLFNBSGxCO0lBT2dGO0lBQTFCO0lBQTFCO0lBQXhCLFlBQTRFLFdBQTFCLFdBQTFCLFVBQXhCOztJQUZGO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSx1RUFBQTs7OztvQkNMRjtNQUFBOytCQUFBLFVBQUE7TUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/form-page/form-page.component.ngfactory.ts